import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProduct } from "src/models/Products/Product.models";

interface ProductState {
  products: IProduct[];
  productToEdit: IProduct | null;
}

const initialState: ProductState = {
  products: [],
  productToEdit: null,
};

const productSlice = createSlice({
  name: "Product",
  initialState,
  reducers: {
    setProductList: (state, action: PayloadAction<IProduct[]>) => {
      state.products = action.payload;
    },
    concatListProduct: (
      state: ProductState,
      action: PayloadAction<IProduct[]>
    ) => {
      state.products = [...state.products.concat(action.payload)];
    },
    setProductToEdit: (state, action: PayloadAction<IProduct | null>) => {
      state.productToEdit = action.payload;
    },
    addProduct: (state, action: PayloadAction<IProduct>) => {
      state.products.push(action.payload);
    },
    addProducts: (state, action: PayloadAction<IProduct[]>) => {
      state.products.push(...action.payload);
    },
    updateProduct: (state, action: PayloadAction<IProduct>) => {
      let itemIndex = state.products.findIndex(
        item => item.productId === action.payload.productId
      );
      if (itemIndex !== -1) state.products[itemIndex] = action.payload;
    },
    updateUnitPriceProduct: (state, action: PayloadAction<IProduct>) => {
      let itemIndex = state.products.findIndex(
        item => item.productId === action.payload.productId
      );
      if (itemIndex !== -1) {
        state.products[itemIndex].unitPrice = action.payload.unitPrice;
      }
    },
    updateUnitPriceProductEditing: (state, action: PayloadAction<IProduct>) => {
      if (state.productToEdit) {
        state.productToEdit.unitPrice = action.payload.unitPrice;
        state.productToEdit.unitPriceVAT = action.payload.unitPriceVAT;
      }
    },
    updateProducts: (state, action: PayloadAction<IProduct[]>) => {
      action.payload.forEach(item => {
        let itemIndex = state.products.findIndex(
          product => product.productId === item.productId
        );
        if (itemIndex !== -1) state.products[itemIndex] = item;
      });
    },
    deleteProduct: (state, action: PayloadAction<number>) => {
      const newArray = state.products.filter(
        item => item.productId !== action.payload
      );
      state.products = newArray;
    },
  },
});

export const {
  setProductList,
  concatListProduct,
  setProductToEdit,
  addProduct,
  addProducts,
  updateProduct,
  updateProducts,
  updateUnitPriceProductEditing,
  updateUnitPriceProduct,
  deleteProduct,
} = productSlice.actions;

export default productSlice.reducer;
